export const ITEM_WEIGHT_FRAGMENT = `
  fragment ItemWeightFragment on ItemWeight {
    id
    weight
    price
  }
`

export const TOTAL_DELIVERY_PRICE_FRAGMENT = `
  fragment TotalDeliveryPriceFragment on TotalDeliveryPrice {
    id
    weightFrom
    weightTo
    price
  }
`
